export const recipesPl = {
  recipes: {
    nav: {
      title: 'Przepisy',
    },
    categories: {
      breakfast: 'Śniadania',
      lunch: 'Obiady',
      dinner: 'Kolacje',
      dessert: 'Desery',
    },
    list: {
      title: 'Przepisy rodzinne',
      subtitle: 'Wspólne przepisy Twojej rodziny',
      create: 'Nowy przepis',
      empty: 'Brak przepisów. Dodaj pierwszy.',
      emptyTitle: 'Brak przepisów',
      noMatches: 'Brak przepisów pasujących do filtrów.',
      searchPlaceholder: 'Szukaj przepisów…',
      allCategories: 'Wszystkie kategorie',
      servings: '{n} porcji',
      open: 'Otwórz',
      delete: 'Usuń',
      deleteConfirm: 'Usunąć ten przepis?',
    },
    detail: {
      title: 'Przepis',
      back: 'Wróć do przepisów',
      edit: 'Edytuj',
      sourceLink: 'Pełny przepis',
      ingredients: 'Składniki',
      addToList: 'Dodaj do listy zakupów',
      addMissing: 'Dorzuć brakujące',
      selectList: 'Wybierz listę',
      addToListSuccess: 'Dodano {added} pozycji ({skipped} pominięto)',
      noLists: 'Najpierw utwórz listę zakupów',
      delete: 'Usuń przepis',
    },
    edit: {
      title: 'Edytuj przepis',
      newTitle: 'Nowy przepis',
      back: 'Wróć',
      save: 'Zapisz',
      saving: 'Zapisywanie…',
      titleLabel: 'Tytuł',
      titlePlaceholder: 'Nazwa przepisu',
      categoryLabel: 'Kategoria',
      servingsLabel: 'Porcje',
      sourceUrlLabel: 'Link do źródła',
      sourceUrlPlaceholder: 'https://…',
      ingredientsLabel: 'Składniki',
      ingredientName: 'Składnik',
      ingredientQty: 'Ilość',
      ingredientUnit: 'Jednostka',
      addIngredient: 'Dodaj składnik',
      tagsLabel: 'Tagi',
      newTagPlaceholder: 'Nowy tag',
      addTag: 'Dodaj tag',
      imageLabel: 'Zdjęcie',
      uploadImage: 'Wgraj zdjęcie',
      removeImage: 'Usuń zdjęcie',
    },
    toasts: {
      created: 'Przepis utworzony',
      saved: 'Przepis zapisany',
      deleted: 'Przepis usunięty',
      error: 'Coś poszło nie tak z przepisem',
      imageUploaded: 'Zdjęcie wgrane',
    },
    import: {
      title: 'Import z linku',
      description: 'Wklej adres strony z przepisem — AI wypełni formularz do potwierdzenia.',
      urlLabel: 'Adres URL',
      urlPlaceholder: 'https://…',
      button: 'Importuj',
      importing: 'Importowanie…',
      success: 'Przepis zaimportowany — sprawdź i zapisz',
      error: 'Nie udało się zaimportować przepisu',
      premiumRequired: 'Import AI wymaga Premium lub własnego klucza OpenRouter',
    },
  },
}
